module.exports = __webpack_public_path__ + "img/aree_docenti.fb317c26.svg";